"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var VideoPlayerElement = function (_a) {
    var source = _a.source, label = _a.label, videoListener = _a.videoListener, style = _a.style, videoRef = _a.videoRef, children = _a.children;
    var ref = (0, react_1.createRef)();
    var usingRef = videoRef || ref;
    (0, react_1.useEffect)(function () {
        if (ref.current && !(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current)) {
            ref.current.volume = 0;
        }
    }, [ref, videoRef]);
    (0, react_1.useEffect)(function () {
        var callback = function (eventName, eventPayload) {
            var _a, _b;
            if (eventName === 'play') {
                (_a = usingRef.current) === null || _a === void 0 ? void 0 : _a.play();
            }
            if (eventName === 'pause') {
                (_b = usingRef.current) === null || _b === void 0 ? void 0 : _b.pause();
            }
            if (eventName === 'seek' && usingRef.current) {
                usingRef.current.currentTime = eventPayload;
            }
        };
        videoListener === null || videoListener === void 0 ? void 0 : videoListener.on(callback);
        return function () {
            videoListener === null || videoListener === void 0 ? void 0 : videoListener.off(callback);
        };
    }, [videoListener, usingRef]);
    return (react_1.default.createElement("div", { className: "ui-video-player-element", style: style },
        children ? (react_1.default.createElement("div", { className: "ui-video-player-children" }, children)) : null,
        label ? (react_1.default.createElement("span", { className: "video-player-label" }, label)) : null,
        react_1.default.createElement("video", { ref: usingRef, src: source })));
};
exports.default = VideoPlayerElement;
